import instance from "../utils/axios";

export const loginUser = async (data) => {
    return await instance.post('/api/auth/login', data)
};

export const fetchUserProfile = async () => {
    return await instance.get('/api/auth/profile');
};


export const fetchUserBalance = async () => {
    return await instance.get('/api/user/balance');
};

export const changePassword = async (data) => {
    const response = await instance.post('api/auth/change-password', data);
    return response.data;
};

export const getPasswordHistory = async () => {
    return await instance.get('api/user/password_history');
}
export const getDeletedUsers = async () => {
    return await instance.get('api/user/deleted-users');
}

export const restoreDeleteUser = async (id) => {
    return await instance.put(`api/user/restore-delete-user/${id}`);
}
export const fetchUsers = async (params = {}) => {
    const {
        page = 1,
        limit = 10,
        search = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
        master_id = null
    } = params;

    const queryParams = {
        page,
        limit,
        search,
        sortBy,
        sortOrder
    };

    if (master_id) {
        queryParams.master_id = master_id;
    }

    return await instance.get('/api/user/all', {
        params: queryParams
    });
};

export const fetchDownlineUsers = async (userId, userType) => {
    return await instance.get(`api/user/all/${userId}/${userType}`)
}
export const fetchAllDownlineUsers = async () => {
    return await instance.get(`api/user/all`)
}

export const deleteUser = async (userId) => {
    return await instance.delete(`/api/user/${userId}`);
};

export const createUser = async (userData) => {
    return await instance.post('/api/user/create', userData);
};
